<template>
    <v-container v-if="loadSkeleton">
        <SkeletonLoader ruta="turnos" tipo="table-heading, card, card"></SkeletonLoader>
    </v-container>
    <v-container v-else>
        <v-card flat>
            <v-card-title class="text-h5 font-weight-bold ">
                <v-icon color="primary" class="mr-3" size="34">mdi-newspaper-variant-outline</v-icon>
                Comunicaciones
                <v-spacer></v-spacer>
            </v-card-title>
            <ComunicacionesCard :items="itemsComu"></ComunicacionesCard>
        </v-card>
    </v-container>

</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import SkeletonLoader from '@/components/alerts/SkeletonLoader.vue'
import { mapActions, mapGetters } from 'vuex';
import ComunicacionesCard from '@/components/cards/ComunicacionesCard';

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        ComunicacionesCard,
        SkeletonLoader
    },

    data() {
        return {
            show: false,
        }
    },
    computed: {
        ...mapGetters('comunicaciones', ['comunicaciones']),
        ...mapGetters('auth', ['loadSkeleton']),

        itemsComu() {
            return this.comunicaciones.map(c => ({ ...c }))
        },
    }
}
</script>